import React, { Component } from 'react'
import { Formik, Form, Field } from 'formik'
import { accountRenewalSchema } from '../schema/account_renewal.schema'
import { Row, Col, Button } from 'react-bootstrap'
import { Select, Input } from '../../../../../ui/forms/formik'
import {
    RenewalTypeSuccessModalToAuto,
    RenewalTypeSuccessModalToManual,
    RenewalCycleSuccessModalToAnnual,
    RenewalCycleSuccessModalToMonthly,
    RenewalCycleConfirmModalToMonthly,
    RenewalBothConfirmModalToManualToMonthly,
    RenewalBothSuccessModalToManualToMonthly,
    RenewalBothSuccessModalToManualToAnnual,
    RenewalBothConfirmModalToAutoToMonthly,
    RenewalBothSuccessModalToAutoToAnnual,
    RenewalBothSuccessModalToAutoToMonthly
} from '../../modals/RenewalModals'

class AccountRenewalFormRow extends Component {
    constructor(props) {
        super(props)

        this.state = {
            enableEdit: false,
            values: { renewalType: 'auto', renewalCycle: 'annual' }, // Inital values
            oldValues: {},
            showModal: ''
        }
    }

    /**
     * Renders
     */

    render() {
        const { values, enableEdit } = this.state;

        return (
            <div className="form-row AccountRenewal-form-row">
                <Formik
                    initialValues={values}
                    validationSchema={accountRenewalSchema}
                    onSubmit={(values, actions) => {
                        this.toggleEdit();
                        this.handleFormSubmit(values, actions);
                    }}
                    validateOnMount
                >{(props) => (
                    <Form className="formik">
                        <Row>
                            <Col xl={12}>
                                <h4 className="form-group-title">Account Renewal</h4>
                            </Col>
                            <Col xl={5} md={6}>
                                {this.renderRenewalType()}
                            </Col>
                            <Col xl={5} md={6}>
                                {this.renderRenewalCycle()}
                            </Col>
                            <Col xl={2}>
                                {enableEdit ? (
                                    <Button
                                        size="xl"
                                        className="form-row-btn lg"
                                        variant="primary"
                                        type="submit"
                                    >Save</Button>
                                ) : (
                                        <Button
                                            size="xl"
                                            className="form-row-btn lg"
                                            variant="secondary"
                                            onClick={(e) => { e.preventDefault(); this.toggleEdit() }}
                                        >Update</Button>
                                    )}
                            </Col>
                        </Row>
                        {this.renderModals(props)}
                    </Form>
                )}
                </Formik>
            </div>
        )
    }

    renderRenewalType = () => {
        const { enableEdit } = this.state;
        const { renewalTypeOptions } = this.props;

        return (
            <Field
                name="renewalType"
                label="Renewal Type"
                placeholder="Renewal Type"
                component={Select}
                className="select select-flat select-xl"
                disabled={!enableEdit}
                options={renewalTypeOptions}
            />
        )
    }

    renderRenewalCycle = () => {
        const { enableEdit } = this.state;
        const { renewalCycleOptions } = this.props;

        return (
            <Field
                name="renewalCycle"
                label="Renewal Cycle"
                placeholder="Renewal Cycle"
                component={Select}
                className="select select-flat select-xl"
                disabled={!enableEdit}
                options={renewalCycleOptions}
            />
        )
    }

    renderModals = (actions) => {
        const { showModal } = this.state;
        
        return (
            <>
                {/* Renewal Type */}
                <RenewalTypeSuccessModalToManual
                    show={showModal === 'renewal_type_success_to_manual'}
                    onHide={() => this.setShowModal('')}
                />
                <RenewalTypeSuccessModalToAuto
                    show={showModal === 'renewal_type_success_to_auto'}
                    onHide={() => this.setShowModal('')}
                />
                {/* Renewal Cycle */}
                <RenewalCycleConfirmModalToMonthly
                    show={showModal === 'renewal_cycle_confirm_to_monthly'}
                    onHide={() => this.handleDicline(actions)}
                    onConfirm={() => this.handleConfirm('cycle', 'to_monthly')}
                />
                <RenewalCycleSuccessModalToMonthly
                    show={showModal === 'renewal_cycle_success_to_monthly'}
                    onHide={() => this.setShowModal('')}
                />
                <RenewalCycleSuccessModalToAnnual
                    show={showModal === 'renewal_cycle_success_to_annual'}
                    onHide={() => this.setShowModal('')}
                />
                {/* Renewal Both */}
                <RenewalBothConfirmModalToManualToMonthly
                    show={showModal === 'renewal_both_confirm_to_manual_to_monthly'}
                    onHide={() => this.handleDicline(actions)}
                    onConfirm={() => this.handleConfirm('both', 'to_manual_to_monthly')}
                />
                <RenewalBothSuccessModalToManualToMonthly
                    show={showModal === 'renewal_both_success_to_manual_to_monthly'}
                    onHide={() => this.setShowModal('')}
                />
                <RenewalBothSuccessModalToManualToAnnual
                    show={showModal === 'renewal_both_success_to_manual_to_annual'}
                    onHide={() => this.setShowModal('')}
                />
                <RenewalBothConfirmModalToAutoToMonthly
                    show={showModal === 'renewal_both_confirm_to_auto_to_monthly'}
                    onHide={() => this.handleDicline(actions)}
                    onConfirm={() => this.handleConfirm('both', 'to_auto_to_monthly')}
                />
                <RenewalBothSuccessModalToAutoToMonthly
                    show={showModal === 'renewal_both_success_to_auto_to_monthly'}
                    onHide={() => this.setShowModal('')}
                />
                <RenewalBothSuccessModalToAutoToAnnual
                    show={showModal === 'renewal_both_success_to_auto_to_annual'}
                    onHide={() => this.setShowModal('')}
                />
            </>
        )
    }

    /**
     * Handlers
     */

    /**
     * The Flow:
     * Button 'Change' clicked and row is enabled =>
     * User choose renewal type and cycle =>
     * User click 'Save' =>
     * Check if just renewal type changed => Submit values => On success how renewal type success modal
     * Check if just renewal cycle changed => Show confirm modal => On confirm submit values
     * Check if both changed => Show both confirm modal => On confirm submit values => On success show success modal
     */
    handleFormSubmit = (values, actions) => {
        const { values: oldValues } = this.state;
        
        this.setState({ values, oldValues });
        this.handleShowNotifyModals(values, oldValues);
    }

    handleShowNotifyModals = (newValues, oldValues) => {
        const isBothChanged = oldValues.renewalType !== newValues.renewalType && oldValues.renewalCycle !== newValues.renewalCycle;
        const justRenewalTypeChanged = oldValues.renewalType !== newValues.renewalType;
        const justRenewalCycleChanged = oldValues.renewalCycle !== newValues.renewalCycle;
        const renewalTypeTo = newValues.renewalType;
        const renewalCycleTo = newValues.renewalCycle;

        if (isBothChanged) {

            if (renewalTypeTo === 'manual' && renewalCycleTo === 'monthly') {
                this.setShowModal('renewal_both_confirm_to_manual_to_monthly');
            } else if (renewalTypeTo === 'manual' && renewalCycleTo === 'annual') {
                this.setShowModal('renewal_both_success_to_manual_to_annual');
            } else if (renewalTypeTo === 'auto' && renewalCycleTo === 'monthly') {
                this.setShowModal('renewal_both_confirm_to_auto_to_monthly');
            } else if (renewalTypeTo === 'auto' && renewalCycleTo === 'annual') {
                this.setShowModal('renewal_both_success_to_auto_to_annual');
            }

        } else if (justRenewalCycleChanged) {

            if (renewalCycleTo === 'annual') {
                // Show confirmation modal that renewal cycle updated from monthly to annual
                this.setShowModal('renewal_cycle_success_to_annual');
            } else if (renewalCycleTo === 'monthly') {
                // Show confirmation modal that renewal cycle updated from monthly to monthly
                this.setShowModal('renewal_cycle_confirm_to_monthly');
            }

        } else if (justRenewalTypeChanged) {

            if (renewalTypeTo === 'auto') {
                // Show success modal
                this.setShowModal('renewal_type_success_to_auto');
            } else if (renewalTypeTo === 'manual') {
                // Show success modal
                this.setShowModal('renewal_type_success_to_manual');
            }

        }
    }

    handleConfirm = (renewal, to) => {
        this.setShowModal(`renewal_${renewal}_success_${to}`);

        // MAKE REQUEST
        console.log(this.state.values);
    }

    handleDicline = (actions) => {
        this.setShowModal('');
        const { oldValues } = this.state;
        // When user don't confirm return the old values

        actions.setFieldValue('renewalType', oldValues.renewalType);
        actions.setFieldValue('renewalCycle', oldValues.renewalCycle);

        this.setState(prevState => ({
            values: prevState.oldValues
        }));
    }

    toggleEdit = () => {
        this.setState(prevState => ({ enableEdit: !prevState.enableEdit }));
    }

    setShowModal = show => {
        this.setState({ showModal: show });
    }

    /**
     * Props
     */
    static defaultProps = {
        renewalTypeOptions: [
            {
                label: 'Auto Renewal',
                value: 'auto'
            },
            {
                label: 'Manual Renewal',
                value: 'manual'
            }
        ],
        renewalCycleOptions: [
            {
                label: 'Annual',
                value: 'annual'
            },
            {
                label: 'Monthly',
                value: 'monthly'
            }
        ],
        lastCardNumber: "X532"
    }
}

export default AccountRenewalFormRow
